var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 58,
    viewBox: "0 0 59 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5974 0.34375H55.5545L23.1552 57.2148H3.50879L36.5974 0.34375Z",
    fill: "#3571BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.53418 28.7793L16.7338 0.34375H0.53418V28.7793Z",
    fill: "#3571BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0947 28.7793L41.8951 57.2148L58.0947 57.2148L58.0947 28.7793Z",
    fill: "#3571BD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZLogo);
export default __webpack_public_path__ + "static/media/zLogo.7f1b177622aa42a306328d8fa78d6c79.svg";
export { ForwardRef as ReactComponent };